/**
 * Bundle Toggle Handler - Simplified
 *
 * Handles expand/collapse functionality for bundle components in cart drawer.
 * All rendering is now done server-side via Liquid templates.
 *
 * @class BundleToggleHandler
 */
class BundleToggleHandler {
	constructor() {
		this.init();
	}

	/**
	 * Initializes toggle functionality on page load and cart updates
	 */
	init() {
		// Setup toggles on initial load
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', () => this.setupAllToggles());
		} else {
			this.setupAllToggles();
		}

		// Re-setup toggles when cart drawer opens
		document.addEventListener('cart-drawer:open', () => {
			setTimeout(() => this.setupAllToggles(), 100);
		});

		// Re-setup toggles when cart is refreshed
		document.addEventListener('cart:refresh', () => {
			setTimeout(() => this.setupAllToggles(), 100);
		});

		// Re-setup toggles when cart drawer is updated
		const cartDrawer = document.querySelector('cart-drawer');
		if (cartDrawer) {
			cartDrawer.addEventListener('cart-drawer:refreshed', () => {
				this.setupAllToggles();
			});

			cartDrawer.addEventListener('cart-drawer:updated', () => {
				this.setupAllToggles();
			});
		}
	}

	/**
	 * Sets up toggle functionality for all bundle components
	 */
	setupAllToggles() {
		const bundleContainers = document.querySelectorAll('.bundle-components');
		bundleContainers.forEach(container => this.setupToggle(container));
	}

	/**
	 * Sets up toggle functionality for a single bundle
	 * @param {HTMLElement} container - The bundle container element
	 */
	setupToggle(container) {
		// Skip if already initialized
		if (container.dataset.toggleInitialized === 'true') return;

		const toggleButtons = container.querySelectorAll('.bundle-toggle');
		const collapsed = container.querySelector('.bundle-collapsed');
		const expanded = container.querySelector('.bundle-expanded');

		// Skip if required elements are missing
		if (!collapsed || !expanded) return;

		const toggleHandler = (e) => {
			e.preventDefault();
			e.stopPropagation();

			const isExpanded = expanded.style.display !== 'none';

			if (isExpanded) {
				// Collapse: show summary view
				collapsed.style.display = 'block';
				expanded.style.display = 'none';
			} else {
				// Expand: show detailed view
				collapsed.style.display = 'none';
				expanded.style.display = 'block';
			}
		};

		// Attach click handlers to all toggle buttons
		toggleButtons.forEach(button => {
			button.removeEventListener('click', toggleHandler);
			button.addEventListener('click', toggleHandler);
		});

		container.dataset.toggleInitialized = 'true';
	}
}

// Initialize bundle toggle handler
new BundleToggleHandler();
